<app-page-header pageTitle="{{ 'components.notFound.title' | translate }}"></app-page-header>
<div class="content">
  <i class="fas fa-exclamation-triangle icon" aria-hidden="true"></i>
  <p class="message">{{ 'components.notFound.message' | translate }}</p>
</div>
